{
  "filter": {
    "all": "Tüm tedarikçiler",
    "country": "country",
    "direct": "Doğrudan tedarikçiler",
    "indirectConfidential": "Dolaylı tedarikçiler, gizli",
    "nonConfidential": "Dolaylı tedarikçiler, gizli değil"
  },
  "list": {
    "countContact_one": "{{count}} Kişi",
    "countContact_other": "{{count}} Kişiler",
    "noAddress": "Adres verilmemiş",
    "noSuppliers": "Tedarikçi bulunamadı",
    "searchPlaceholder": "Ara",
    "supplierTypePlaceholder": "Tedarikçi türü"
  },
  "productionSites": {
    "columns": {
      "confidential": "Gizli tedarikçi",
      "contactEmail": "İletişim e-postası",
      "country": "Ülke",
      "internalCode": "Dahili kod",
      "name": "Ad",
      "performedActivities": "Yapılan faaliyetler",
      "registrationId": "Tesis kayıt kimlikleri"
    },
    "filters": {
      "searchPlaceholder": "Ara"
    },
    "search": {
      "placeholder": "Ara"
    },
    "title": "Üretim yerleri"
  },
  "repository": {
    "actions": {
      "delete": "Sil",
      "edit": "Düzenle"
    },
    "create": {
      "error": {
        "message": "The business partner has not been created",
        "title": "Error creating business partner"
      },
      "success": {
        "message": "The business partner has been created successfully",
        "title": "Business partner created"
      }
    },
    "delete": {
      "error": {
        "message": "The business partner has not been deleted",
        "title": "Error deleting business partner"
      },
      "success": {
        "message": "The business partner has been deleted successfully",
        "title": "Business partner deleted"
      }
    },
    "title": "All",
    "update": {
      "error": {
        "message": "The business partner has not been updated",
        "title": "Error updating business partner"
      },
      "success": {
        "message": "The business partner has been updated successfully",
        "title": "Business partner updated"
      }
    }
  },
  "risk": {
    "high": "Yüksek",
    "low": "Düşük",
    "medium": "Orta",
    "table": {
      "certificationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      },
      "collaborationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      }
    }
  },
  "sort": {
    "averageResponseTime": "averageResponseTime",
    "company": "company",
    "completedProductionSiterequests": "completedProductionSiterequests",
    "completedProductrequests": "completedProductrequests",
    "completedScopeCertificaterequests": "completedScopeCertificaterequests",
    "completedTransactionCertificaterequests": "completedTransactionCertificaterequests",
    "email": "email",
    "lastConnectionDate": "lastConnectionDate",
    "lastReminderDate": "lastReminderDate",
    "name": "name",
    "pendingDocumentrequests": "pendingDocumentrequests",
    "pendingProductionSiterequests": "pendingProductionSiterequests",
    "pendingProductrequests": "pendingProductrequests",
    "pendingScopeCertificaterequests": "pendingScopeCertificaterequests",
    "pendingTransactionCertificaterequests": "pendingTransactionCertificaterequests"
  },
  "subSuppliers": {
    "title": "Tedarikçilerim"
  },
  "supplier": {
    "averageResponseTime": "Ortalama yanıt süresi",
    "averageResponseTimeValue_one": "{{nbDays}} gün",
    "averageResponseTimeValue_other": "{{nbDays}} gün",
    "informationRequests": "Ürün talepleri",
    "lastConnection": "Son bağlantı",
    "lastConnectionValue": "{{nbDays}} gün önce",
    "lastReminderSent": "Son e-posta gönderildi",
    "lastReminderSentValue": "{{nbDays}} gün önce",
    "noLastConnection": "Henüz bağlantı yok",
    "noLastReminderSent": "Henüz e-posta gönderilmedi",
    "noResponseTime": "Henüz yanıt yok",
    "productionSites": "Üretim Yerleri",
    "scopeCertificates": "Kapsam Belgeleri",
    "transactionCertificates": "İşlem Belgeleri",
    "transferContact_one": "{{count}} Tamamlanmamış isteği\nbaşka bir kişiye aktar",
    "transferContact_other": "{{count}} Tamamlanmamış istekleri\nbaşka bir kişiye aktar",
    "transferContactCertificates_one": "transferContactCertificates",
    "transferContactCertificates_other": "transferContactCertificates",
    "transferModal": {
      "companyCountry": "companyCountry",
      "companyCountryPlaceholder": "companyCountryPlaceholder",
      "companyName": "companyName",
      "companyNamePlaceholder": "companyNamePlaceholder",
      "email": "E-posta",
      "emailPlaceholder": "örn: ahmet@firmam.com",
      "name": "Ad",
      "namePlaceholder": "örn: Ahmet Yılmaz",
      "title": "Kişiyi aktar",
      "transfer": "Aktar",
      "transferSuccess_one": "transferSuccess",
      "transferSuccess_other": "transferSuccess"
    }
  },
  "title": "İş ortakları"
}
